import { type RtkQueryLayers } from '../../core';
import { storagesOGService } from './storages.og';

export const storagesRTKQueryLayers: RtkQueryLayers = {
  reducers: {
    [storagesOGService.reducerPath]: storagesOGService.reducer,
  },
  middlewares: [storagesOGService.middleware],
};
